import { useState, useEffect, useMemo } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { usePosts } from "../hooks/queries/usePosts";

const useViewPostsFacade = () => {
  const navigate = useNavigate();
  const { search } = useLocation();
  const companyParam = new URLSearchParams(search).get("company");

  const { user } = useSelector((state) => state.user);
  const myCollegeName = (user?.collegeName || "").trim();

  const [postScope, setPostScope] = useState("global"); // "global" | "campus"
  const [searchTerm, setSearchTerm] = useState("");
  const [showFilters, setShowFilters] = useState(false);
  const [activeFilters, setActiveFilters] = useState(null);

  // Used to force re-render/clear inside FilterPosts
  const [resetToggle, setResetToggle] = useState(false);

  useEffect(() => {
    if (companyParam) setSearchTerm(companyParam);
  }, [companyParam]);

  const { data, isLoading: loading, fetchNextPage, hasNextPage, isFetchingNextPage } = usePosts({
    collegeName: myCollegeName,
    scope: postScope,
    search: searchTerm,
    type: activeFilters?.type || "",
    status: activeFilters?.status || ""
  });

  const filteredPosts = useMemo(() => {
    if (!data) return [];
    return data.pages.flatMap((page) => page.posts);
  }, [data]);

  const handleFilter = (filters) => setActiveFilters(filters);

  const resetAllFilters = () => {
    setSearchTerm("");
    setActiveFilters(null);
    setResetToggle(!resetToggle);
  };

  return {
    loading,
    filteredPosts,
    searchTerm,
    setSearchTerm,
    showFilters,
    setShowFilters,
    handleFilter,
    resetAllFilters,
    resetToggle,
    navigate,
    postScope,
    setPostScope,
    myCollegeName,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage
  };
};

export default useViewPostsFacade;
